import { FixedSizeList } from 'react-window'
import { Option } from './styles'
import { forwardRef } from 'react'
import { CSSProperties } from 'react'
import { IOption } from './index'
import Checkbox from '../Checkbox'

const PADDING_SIZE = 4

interface IProps {
  options: IOption[] | { item: IOption }[]

  selected: IOption[]
  onChange(value: IOption[]): void
}

const OptionsList = (props: IProps) => {
  const renderOption = (listParams: { index: number; style: CSSProperties }) => {
    const option = (() => {
      const option_ = props.options[listParams.index]

      if ('item' in option_) return option_.item

      return option_
    })()

    const index = props.selected.findIndex((option_) => option_.value === option.value)

    const isSelected = index !== -1

    return (
      <Option
        key={option.value}
        onClick={() => {
          const newState = [...props.selected]

          if (isSelected) {
            newState.splice(index, 1)
          } else {
            newState.push(option)
          }

          props.onChange(newState)
        }}
        data-selected={isSelected}
        style={{
          ...listParams.style,
          top: `${parseFloat(listParams.style.top as string) + PADDING_SIZE}px`,
        }}
      >
        <Checkbox value={isSelected} className="checkbox" />
        <p className="label" title={option.title || option.label}>
          {option.label}
        </p>
      </Option>
    )
  }

  return (
    <FixedSizeList
      height={Math.min(props.options.length * 38 + PADDING_SIZE * 2, 180)}
      itemCount={props.options.length}
      itemSize={38}
      width="100%"
      innerElementType={innerElementType}
      className="fixed-size-list"
    >
      {renderOption}
    </FixedSizeList>
  )
}

const innerElementType = forwardRef<any, any>(({ style, ...rest }, ref) => (
  <div
    ref={ref}
    style={{
      ...style,
      height: `${parseFloat(style.height) + PADDING_SIZE * 2}px`,
    }}
    {...rest}
  />
))
innerElementType.displayName = 'innerElementType'

export default OptionsList
